module.exports = __webpack_public_path__ + "media/img/event/Scholarships2u_watch-live-video-d732b18f6bcb9c384ce5c3443adff362.svg";